import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';

const initialState = {
  students: [],
  queriedStudent: {}
};

const slice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    // Changes `queriedStudent`
    getStudentProfile(state, action) {
      state.queriedStudent = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const getStudentProfile = studentId => async dispatch => {
  try {
    const response = await axios.get(`/students/${studentId}`);
    dispatch(slice.actions.getStudentProfile(response.data));
  } catch (error) {
    console.log('slices > profile.js > getProfile', error);
  }
};

export default slice;
